"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCode(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M15.284 1.033c.371.11.596.479.537.852l-.024.101L9.67 22.412a.766.766 0 01-1.49-.339l.023-.101L14.33 1.546a.766.766 0 01.954-.513zm3.298 5.226l.086.074 5.107 5.104a.766.766 0 01.075.998l-.074.085-5.108 5.109a.766.766 0 01-1.157-.997l.074-.086 4.564-4.567-4.564-4.563a.766.766 0 01-.074-.997l.074-.086a.766.766 0 01.997-.074zM6.415 6.33a.766.766 0 01.074.997l-.074.086L1.85 11.98l4.565 4.564a.766.766 0 01.074.997l-.074.086a.766.766 0 01-.997.074l-.086-.074-5.107-5.104a.766.766 0 01-.075-.998l.074-.086 5.108-5.108c.299-.3.784-.3 1.083 0z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgCode;
exports.default = _default;